import { render, staticRenderFns } from "./dialog-payment.vue?vue&type=template&id=24cf498f&scoped=true&"
import script from "./dialog-payment.vue?vue&type=script&lang=js&"
export * from "./dialog-payment.vue?vue&type=script&lang=js&"
import style0 from "./dialog-payment.vue?vue&type=style&index=0&id=24cf498f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cf498f",
  null
  
)

export default component.exports